import { toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const showToast = (type = 'info', message, timeout = 3000) => {
  const config = {
    position: "bottom-center", // use string instead of enum if preferred
    autoClose: timeout,
    transition: Slide,
  };

  switch (type) {
    case 'success':
      toast.success(message, config);
      break;
    case 'error':
      toast.error(message, config);
      break;
    case 'warning':
      toast.warning(message, config);
      break;
    default:
      toast.info(message, config);
      break;
  }
};
